/**
 * @generated SignedSource<<b226d37a1955d547e0d91d7b83e84dd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useWorkspaceTodoEditSetTitleMutation$variables = {
  id: string;
  title: string;
};
export type useWorkspaceTodoEditSetTitleMutation$data = {
  readonly todoWorkspace: {
    readonly updateTitle: {
      readonly id: string;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type useWorkspaceTodoEditSetTitleMutation = {
  response: useWorkspaceTodoEditSetTitleMutation$data;
  variables: useWorkspaceTodoEditSetTitleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "newTitle",
    "variableName": "title"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useWorkspaceTodoEditSetTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateTitle",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useWorkspaceTodoEditSetTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateTitle",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c911fe49e26308ba876806c1f16182d8",
    "id": null,
    "metadata": {},
    "name": "useWorkspaceTodoEditSetTitleMutation",
    "operationKind": "mutation",
    "text": "mutation useWorkspaceTodoEditSetTitleMutation(\n  $id: ID!\n  $title: String!\n) {\n  todoWorkspace(id: $id) {\n    updateTitle(newTitle: $title) {\n      id\n      title\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "8fbbb2417c34d6a9d74b83182dd7123c";

export default node;
